import { useEffect, useState } from 'react';
import { message, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import ApiError from '../core/ApiError';
import SurveysService from './SurveysService';
import QuestionsList from './components/QuestionsList';

import styles from './surveypage.module.css';
import Helmet from 'react-helmet';
import { useNavigate, useParams } from 'react-router-dom';

const SurveyTestPage = () => {
    const navigate = useNavigate();
    const { muuid } = useParams() as { muuid: string };
    if (!/[0-9a-fA-F]{6}[0-9a-fA-F]{6}/.test(muuid))
        navigate('/404', { replace: true });

    const [survey, setSurvey] = useState<any>(null);
    const [bgImage, setBgImage] = useState<string>();
    const [bgColor, setBgColor] = useState<string>();

    const onQuestionSubmit = async () => {
        return Promise.resolve(true);
    };

    useEffect(() => {
        const querySurvey = async (uuid: string, cuuid: string) => {
            try {
                const survey = await SurveysService.getPublicSurveyByUUID(
                    uuid,
                    cuuid
                );

                const theme = survey
                    ? { ...survey.theme, ...(survey.config || {}).theme }
                    : null;

                let bgImage = undefined;
                let bgColor = undefined;

                if (theme) {
                    if (theme.background_image) {
                        var gradColor =
                            theme.background_color || 'rgba(0,0,0,0)';
                        bgImage = `linear-gradient(0deg, ${gradColor}, ${gradColor}), url(${theme.background_image})`;
                    } else {
                        bgColor = theme.background_color || undefined;
                    }
                }

                setSurvey(survey);
                setBgImage(bgImage);
                setBgColor(bgColor);
            } catch (err) {
                if (err instanceof ApiError && err.data.code === '20001') {
                    navigate('/404', { replace: true });
                } else {
                    message.error((err as Error).message);
                }
            }
        };

        const id = muuid.substring(0, 6);
        const cid = muuid.substring(6);

        console.log('id is', id, cid);
        if (['26a32c', 'bbbcd4', 'a89ad0'].indexOf(id) >= 0)
            navigate(`/surveys/${muuid}`, { replace: true });

        querySurvey(id, cid);
    }, [muuid, navigate]);

    return (
        <>
            <div
                className={`${styles.bg} qr-bg`}
                style={{ backgroundImage: bgImage, backgroundColor: bgColor }}
            ></div>
            <div className={styles.surveyPage}>
                <QuestionsList
                    mode="FillOut"
                    survey={survey}
                    questions={survey ? survey.questions : null}
                    lazyRender
                    onQuestionSubmit={onQuestionSubmit}
                />
            </div>
            {!!survey && (
                <>
                    <Helmet>
                        <title>{`Prueba Intrena QR: ${survey.title} - ${survey.config.title}`}</title>
                    </Helmet>
                    <Tooltip
                        color="orange"
                        title={`PRUEBA: ${survey.title} - ${survey.config.title}`}
                        className={styles.infoButton}
                        placement="bottomLeft"
                    >
                        <InfoCircleOutlined style={{ color: 'orange' }} />
                    </Tooltip>
                </>
            )}
        </>
    );
};

export default SurveyTestPage;
